import { Component } from '@angular/core';

@Component({
  selector: 'app-experience',
  templateUrl: './experience.component.html',
  styleUrls: ['../audit-theme.css', './experience.component.css'],
})
export class ExperienceComponent {
  public selectedTab: string = 'ux';
}
